import { ConfirmDialog } from "@nymbl/nos2-rules";
import { useRejectClaim } from "@/hooks/use-expenses";
import { EXPENSE_REJECT_MAX, type ExpenseDetail } from "@/schemas/expenses";

interface RejectDialogProps {
  claim: ExpenseDetail;
  onClose: () => void;
  onDone: () => void;
}

/** Reject with a required reason; the claimant gets it by email (R10). */
export function RejectDialog({ claim, onClose, onDone }: RejectDialogProps) {
  const reject = useRejectClaim();
  return (
    <ConfirmDialog
      open
      onOpenChange={(open) => !open && !reject.isPending && onClose()}
      title="Reject expense"
      description="Give a reason. The person is emailed."
      hideDescription
      confirmLabel="Reject"
      variant="destructive"
      loading={reject.isPending}
      reason={{ label: "Reason", maxLength: EXPENSE_REJECT_MAX }}
      onConfirm={(note) => reject.mutate({ id: claim.id, note }, { onSuccess: onDone })}
    />
  );
}
